import React from 'react'
import StudentProfileBenefits from '../../componentsGeneral/componentsSuperUser/studentProfile/studentProfileBenefits/StudentProfileBenefits'

const StudentsBenefits = () => {
  return (
    <div>
        <StudentProfileBenefits/>
    </div>
  )
}

export default StudentsBenefits